<template>
  <div class="user-info-form">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="modern-form" :class="{ loading }">
      <el-form-item label="用户昵称" prop="nickName">
        <el-input 
          v-model="form.nickName" 
          maxlength="30" 
          placeholder="请输入用户昵称"
          class="modern-input"
        />
      </el-form-item> 
      <el-form-item label="手机号码" prop="phonenumber">
        <el-input 
          v-model="form.phonenumber" 
          maxlength="11" 
          placeholder="请输入手机号码"
          class="modern-input"
        />
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input 
          v-model="form.email" 
          maxlength="50" 
          placeholder="请输入邮箱地址"
          class="modern-input"
        />
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="form.sex" class="modern-radio-group">
          <el-radio value="0" class="modern-radio">
            <span class="radio-label">男</span>
          </el-radio>
          <el-radio value="1" class="modern-radio">
            <span class="radio-label">女</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="form-actions">
        <el-button 
          type="primary" 
          size="default" 
          @click="submit"
          class="action-btn save-btn"
          :loading="loading"
        >
          <svg-icon icon-class="star" class="btn-icon" />
          保存
        </el-button>
        <el-button 
          type="danger" 
          size="default" 
          @click="close"
          class="action-btn cancel-btn"
        >
          <svg-icon icon-class="exit-fullscreen" class="btn-icon" />
          关闭
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { updateUserProfile } from "@/service/main/system/user";

export default {
  props: {
    user: {
      type: Object
    }
  },
  data() {
    return {
      form: {},
      loading: false,
      // 表单校验
      rules: {
        nickName: [
          { required: true, message: "用户昵称不能为空", trigger: "blur" }
        ],
        email: [
          { required: true, message: "邮箱地址不能为空", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        phonenumber: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    user: {
      handler(user) {
        if (user) {
          this.form = { nickName: user.nickName, phonenumber: user.phonenumber, email: user.email, sex: user.sex };
        }
      },
      immediate: true
    }
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.loading = true;
          updateUserProfile(this.form).then(response => {
            console.log('response',response)
            this.$modal.msgSuccess("修改成功");
            // 通过事件通知父组件更新数据
            this.$emit('update-user-info', {
              phonenumber: this.form.phonenumber,
              email: this.form.email
            });
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    close() {
      this.$tab.closePage();
    }
  }
};
</script>

<style lang="scss" scoped>
.user-info-form {
  .modern-form {
    position: relative;
    
    // 添加加载遮罩
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 12px;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      z-index: 10;
      backdrop-filter: blur(2px);
    }
    
    &.loading::after {
      opacity: 1;
      visibility: visible;
    }
    .el-form-item {
      margin-bottom: 25px;
      position: relative;
      
      .el-form-item__label {
        font-weight: 500;
        color: #333;
        font-size: 14px;
        transition: all 0.3s ease;
      }
      
      &:focus-within {
        .el-form-item__label {
          color: #667eea;
          transform: translateX(5px);
        }
      }
      
      .el-form-item__content {
        .modern-input {
          position: relative;
          
          ::v-deep .el-input__inner {
            border-radius: 12px;
            border: 2px solid #f0f0f0;
            padding: 15px 20px;
            font-size: 14px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: #fafafa;
            box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
            
            &:focus {
              border-color: #667eea;
              background: white;
              box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1), inset 0 2px 4px rgba(0, 0, 0, 0.05);
              transform: translateY(-1px);
            }
            
            &:hover {
              border-color: #c0c4cc;
              background: white;
              transform: translateY(-1px);
            }
            
            &::placeholder {
              color: #999;
              font-style: italic;
              transition: all 0.3s ease;
            }
            
            &:focus::placeholder {
              opacity: 0.7;
              transform: translateX(5px);
            }
          }
          
          ::v-deep .el-input__wrapper {
            box-shadow: none;
            background: transparent;
          }
          
          // 添加输入框聚焦时的光晕效果
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: 12px;
            background: linear-gradient(135deg, #667eea, #764ba2);
            opacity: 0;
            transition: opacity 0.3s ease;
            z-index: -1;
          }
          
          &:focus-within::before {
            opacity: 0.1;
          }
        }
        
        .modern-radio-group {
          .modern-radio {
            margin-right: 30px;
            
            ::v-deep .el-radio__input {
              .el-radio__inner {
                border-radius: 50%;
                border: 2px solid #e8e8e8;
                width: 20px;
                height: 20px;
                transition: all 0.3s ease;
                background: #fafafa;
                
                &:hover {
                  border-color: #667eea;
                  background: white;
                }
              }
              
              &.is-checked {
                .el-radio__inner {
                  border-color: #667eea;
                  background: #667eea;
                  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
                  
                  &::after {
                    background: white;
                    width: 8px;
                    height: 8px;
                  }
                }
              }
            }
            
            .radio-label {
              font-size: 14px;
              color: #333;
              margin-left: 8px;
              font-weight: 500;
            }
          }
        }
      }
    }
    
    .form-actions {
      margin-top: 40px;
      padding-top: 30px;
      border-top: 1px solid #f0f0f0;
      text-align: center;
      
      .action-btn {
        padding: 12px 30px;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 500;
        border: none;
        transition: all 0.3s ease;
        margin: 0 10px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        
        .btn-icon {
          margin-right: 6px;
          font-size: 14px;
        }
        
        &.save-btn {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
          }
          
          &:active {
            transform: translateY(0);
          }
        }
        
        &.cancel-btn {
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
          
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(255, 107, 107, 0.3);
          }
          
          &:active {
            transform: translateY(0);
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .user-info-form {
    .modern-form {
      .el-form-item {
        margin-bottom: 20px;
        
        .el-form-item__label {
          font-size: 13px;
        }
        
        .el-form-item__content {
          .modern-input {
            ::v-deep .el-input__inner {
              padding: 10px 12px;
              font-size: 13px;
            }
          }
          
          .modern-radio-group {
            .modern-radio {
              margin-right: 20px;
              
              .radio-label {
                font-size: 13px;
              }
            }
          }
        }
      }
      
      .form-actions {
        margin-top: 30px;
        padding-top: 20px;
        
        .action-btn {
          padding: 10px 20px;
          font-size: 13px;
          margin: 0 5px;
        }
      }
    }
  }
}
</style>
